import type { ComputedRef } from 'vue';
import { computed } from 'vue';
import { useRoute } from 'vue-router';

import { MirrorTrackingNamespace, MirrorTrackingType } from '@modules/mirrors-list/enums';

interface MirrorsListNameSpaceComposable {
  isMirrorJsNamespace: ComputedRef<boolean>;
  isMirrorNoJsNamespace: ComputedRef<boolean>;
  mirrorNamespaceType: ComputedRef<MirrorTrackingType>;
  mirrorNamespaceParams: ComputedRef<MirrorTrackingNamespace>;
}

export default function useMirrorsListNamespace(): MirrorsListNameSpaceComposable {
  const route = useRoute();

  const isMirrorJsNamespace = computed(() => (route.params.mirrorsNamespace === MirrorTrackingNamespace.LIST_JS));
  const isMirrorNoJsNamespace = computed(() => (route.params.mirrorsNamespace === MirrorTrackingNamespace.LIST_NO_JS));
  const mirrorNamespaceType = computed(() => (isMirrorJsNamespace.value ? MirrorTrackingType.COMMON_TYPE : MirrorTrackingType.NO_JS_TYPE));
  const mirrorNamespaceParams = computed(() => (isMirrorJsNamespace.value ? MirrorTrackingNamespace.LIST_JS : MirrorTrackingNamespace.LIST_NO_JS));

  return {
    isMirrorJsNamespace,
    isMirrorNoJsNamespace,
    mirrorNamespaceType,
    mirrorNamespaceParams,
  };
}
